export default ()=>{
   
    const loginModals = document.querySelectorAll('[data-login-modal]');
    const accountOpen = document.querySelector('[data-open-login]');

    loginModals.length >0 && accountOpen? loginHandle():false;

    function loginHandle(){
        loginModals.forEach(modal =>{
            const closeButton = modal.querySelector('.sign-up-window_close');
            
            accountOpen.addEventListener('click', ()=>{
                modal.classList.contains('active')? modal.classList.remove('active'):  modal.classList.add('active')
               
            })
            closeButton.addEventListener('click', ()=>{
                modal.classList.remove('active')
            })

            document.addEventListener("click", toggleDropdown);

            function toggleDropdown(event) { 
                if (accountOpen.contains(event.target) || modal.querySelector('.sign-up-window').contains(event.target)) return;
                modal.classList.remove('active')
            }

            const buttons = document.querySelectorAll('[data-login-open]');
            const tabs = document.querySelectorAll('.login-wrapper');

            buttons.forEach(button =>{
                const modalName = button.dataset.loginOpen;
                button.addEventListener('click', ()=>{
                    tabs.forEach(tab =>{
                        tab.dataset.tab == modalName?tab.classList.add('active'):tab.classList.remove('active');
                    })
                })
            })
        })
    }

    
}